import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=2d7dfee7&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7dfee7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7dfee7')) {
      api.createRecord('2d7dfee7', component.options)
    } else {
      api.reload('2d7dfee7', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=2d7dfee7&scoped=true&", function () {
      api.rerender('2d7dfee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lK1yRvwVK7PU/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports